// extracted by mini-css-extract-plugin
export var gallery = "Gallery-module--gallery--ZQPT8";
export var list = "Gallery-module--list--qvaZe";
export var noPhoto = "Gallery-module--noPhoto--aS2m2";